<template>  
   <footer class="it-footer"  v-once>
      <div class="it-footer-main">
         <div class="container">
            <div class="row clearfix">
               <div class="col-sm-12">
                  <div class="it-brand-wrapper">
                     <a href="/bootstrap-innovatori/">
                        <div class="it-brand-text">
                           <h2 class="no_toc">Programma S3 <span>Sardegna</span></h2>
                        </div>
                     </a>
                  </div>
               </div>
            </div>

            <div class="row">
               <div class="col-lg-3 col-md-3 col-sm-6 pb-2 d-print-none">
                  <h6 class="border-white border-bottom font-weight-normal pb-2">
                     <span>MENU</span>
                  </h6>
                  <div class="link-list-wrapper">
                     <main-menu :bottom="true" :level="1" v-bind:menuList="menuList"/>
                  </div>
               </div>
               <div class="col-lg-8 col-md-8 col-sm-6 pb-2">
                  <h6 class="border-white border-bottom font-weight-normal pb-2">
                     <span class="text-uppercase" ><slot name="titolo"></slot></span>
                  </h6>
                  
                  <div class="row">
                     <div class="col-12 col-md-6">
                        <p>         
                           <slot name="blockFirst"></slot>
                        </p>
                     </div>
                     <div class="col-12 col-md-6">
                        <p>                        
                         <slot name="blockSecond"></slot>
                        </p>
                     </div>

                  </div>
               </div>
            </div>
            
            <div class="row">
               <div class="col-12 col-md-9 my-5 footer-icons">
                  <ul class="nav list-inline d-flex justify-content-between">
                     <li class="list-inline-item mr-0"><img class="mr-0 my-2" src="@/assets/img/EU-logo.svg" alt="Unione Europea"></li>
                     <li class="list-inline-item mr-0"><img class="mr-0 my-2" src="@/assets/img/Repubblica-Italiana.svg" alt="Repubblica Italiana"></li>
                     <li class="list-inline-item mr-0"><img class="mr-0 my-2" src="@/assets/img/ras-logo-negativo.svg" alt="Regione Autonoma della Sardegna"></li>
                     <li class="list-inline-item mr-0"><img class="mr-0 my-2" src="@/assets/img/POR-FESR.svg" alt="POR FESR 2014-2020"></li>    
                  </ul>              
               </div>
            </div>      

         </div>
      </div>

      <div class="it-footer-small-prints clearfix d-print-none">
         <div class="container">
            <h3 class="sr-only">Sezione Link Utili</h3>

            <ul class="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row">                           
               <li class="list-inline-item" v-for="(item, name, index) in miniMenuList" :key="index">
                  <a v-if="item.tipo == 'ESTERNO'" :href="item.linkUrl" target="_blank">{{ item.nome }}</a>
                  <!-- a v-else :href="item.linkUrl">{{ item.nome }}</a-->
                  <router-link v-else
                     active-class="-active"
                     :to="{name: item.nome, params: {id: item.idFonteDati, slug: item.slug, title: item.nome } }"
                     :key="item.nome"
                  >{{ item.nome }}</router-link>
               </li>
            </ul>
         </div>         
      </div>
      <div class="container">
         <div class="text-white text-right small mt-3">
            &copy; {{year}} Regione Autonoma della Sardegna
         </div>
      </div>
      <cookie-law v-on:accept="enableTracking()" :buttonText="`accetto`" :buttonClass="`btn btn-outline-primary text-uppercase`" :theme="`bsi`" class="bg-dark" :message="cookieContent" :storageName="`ras.cookies.policy`" :storageType="`cookies`" :cookieOptions="{expires: `1Y`, secure: true, samesite: true}">
        <div slot="message"><vue-markdown>{{cookieContent}}</vue-markdown></div>        
      </cookie-law>
   </footer>    
</template>

<script>
  import CookieLaw from 'vue-cookie-law';
  import { getPost } from './../service';
  import VueMarkdown from 'vue-markdown';

  export default {
   name: 'app-footer',
   components: { 
      CookieLaw, 
      VueMarkdown 
   },
   props: {
      menuList: {
         type: Array,
         description: "menuItems as array"
      },      
      miniMenuList: {
         type: Array,
         description: "menuItems as array"
      },
      cookiebar:{
         type:Object
      }    
   }, 
   data() {
      return {
         year: new Date().getFullYear(),
         cookieContent: "Questo sito utilizza \"cookie\" per migliorare l'esperienza di navigazione;salvare le preferenze e raccogliere informazioni statitistiche traffico; per maggiori informazioni sulle modalità di gestione o cancellazione dei cookie, clicca su questo [link](/cookie-policy)  per leggere l'informativa dettagliata.",
         errors: []
      }
   },
   methods:{
      enableTracking () {      
         if(this.$cookies.get('ras.cookies.policy') !== true){
            this.$cookies.set('ras.cookies.policy', true, '1Y');
         }
      },
      parseCookieContent: function(response){
         return response.data.corpo.iv         
      },  
   },

   async created() {
      //let currStorage = window.localStorage;
      //if(!currStorage['ras.cookies.policy']){
      if(this.$cookies.get('ras.cookies.policy') === null){
         try {
            const result = await getPost(this.$props.cookiebar.idFonteDati, '');
            this.cookieContent = this.parseCookieContent(result.items[0]); 
         }   catch (e) {
            this.errors.push(e)
         }
      }
   },
   watch: {
      cookieContent: function(){         
         return this.cookieContent;
      }
   }      
};
</script>
<style >
.footer-icons img{ min-width:100px; }
.Cookie--bsi { 
   -webkit-transform: translateX(00%);
   transform: translateX(0%);
   border-radius: 4px 4px 0 0;
   bottom: 0;
   position: fixed;
   width: 100%;
   z-index: 1100;
   background-color: #30373d !important;
   padding: 24px 32px;
   color: #FFF;   
   display: flex;
   justify-content: center;
   font-size: 16px;
}
.Cookie--bsi a{
   color: #CDCDCD;
}
.Cookie--bsi > .Cookie__content{   
   max-width: 920px;
   width: 75%;
}
.Cookie--bsi > .Cookie__buttons{

}
</style>
